import {
  createStyles,
  makeStyles,
  Theme,
  TypographyProps,
  Typography as MUITypography,
} from '@material-ui/core';
import React, { ElementType } from 'react';
import classNames from 'classnames';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    menu: {
      ...theme.typography.h3,
      fontSize: '16px !important',
    },
    list1: {
      fontFamily: theme.typography.h3.fontFamily,
      fontSize: '16px',
      lineHeight: '22px',
    },
    list2: {
      fontFamily: theme.typography.h3.fontFamily,
      fontSize: '14px',
    },
    'number-bold': {
      fontFamily: theme.typography.h3.fontFamily,
      fontSize: '16px',
      fontWeight: 'bold',
      color: theme.palette.text.primary,
    },
    text: {
      fontFamily: theme.typography.h3.fontFamily,
      fontSize: '14px',
      color: '#576164',
    },
    'button-small': {
      fontFamily: theme.typography.h3.fontFamily,
      fontSize: '14px',
      fontWeight: 'bold',
      lineHeight: '16px',
      color: 'black',
    },
  })
);

type Props = Omit<TypographyProps, 'variant'> & {
  variant?:
    | TypographyProps['variant']
    | 'menu'
    | 'list1'
    | 'list2'
    | 'number-bold'
    | 'text'
    | 'button-small';
  component?: ElementType;
};

export const Typography: React.FC<Props> = (props) => {
  const classes = useStyles();
  const isCustom =
    props.variant && Object.keys(classes).indexOf(props.variant) > -1;
  return (
    <MUITypography
      {...props}
      variant={isCustom ? undefined : (props.variant as any)}
      className={
        isCustom
          ? classNames(classes[props.variant || ''], props.className)
          : props.className
      }
    >
      {props.children}
    </MUITypography>
  );
};
